import { CoreModule, LicenseManager } from 'dynamsoft-barcode-reader-bundle';

CoreModule.engineResourcePaths.rootDirectory = 'https://cdn.jsdelivr.net/npm/';
LicenseManager.initLicense(
    'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAyMDY3Mzc2LXIxNzQzNDQ4MjY2IiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAyMDY3Mzc2Iiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6MTM0MTQxMzQwNX0='
);
CoreModule.loadWasm(['DBR']);
